export const ROLE_LEGAL_ADMIN = '8';
export const ROLE_LEGAL_USER = '9';
export const ROLE_PRODUCT_COMMENTS_ADMIN = '11';
export const ROLE_TV_LEGAL_ADMIN = '17';
